<template>
  <span class="ima-sign-status-label" :data-status="status.id">
    {{status.name}}
  </span>
</template>

<script>
export default {
  name: 'ima-sign-status-label',
  props: ['status']
}
</script>

<style lang="scss">
@import '../scss/settings';

.ima-sign-status-label {
  @for $i from 1 through length($signStatus) {
    &[data-status='#{$i}'] {
      white-space: nowrap;
      background: nth($signStatus, $i);
      color: #fff;
      font-size: 0.8rem;
      padding: 0.2rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SignStatusLabel.vue